import { Facebook, Instagram, Youtube, Heart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { buildSocialUrl } from '@/lib/social-links';
import { trackFollowClick } from '@/lib/follow-prompt';

interface FollowUsCardProps {
  placement?: string;
  variant?: 'default' | 'compact';
  title?: string;
  description?: string;
  className?: string;
}

export function FollowUsCard({
  placement = 'inline',
  variant = 'default',
  title = 'Kan du lide det, vi laver?',
  description = 'Vi er et lille dansk site og kun lige startet. Følg med — det betyder alt for os, at du gør det.',
  className = '',
}: FollowUsCardProps) {
  const isCompact = variant === 'compact';
  return (
    <Card className={`p-4 sm:p-5 bg-muted/40 border-accent/30 ${className}`}>
      <div className={`flex ${isCompact ? 'flex-row items-center' : 'flex-col sm:flex-row sm:items-center'} gap-4`}>
        <div className="flex-1 min-w-0">
          <h3 className="font-display font-semibold text-base sm:text-lg flex items-center gap-2">
            <Heart className="w-4 h-4 text-accent" aria-hidden="true" />
            {title}
          </h3>
          {!isCompact && (
            <p className="text-sm text-muted-foreground mt-1">{description}</p>
          )}
        </div>
        <div className="flex flex-wrap gap-2 shrink-0">
          <Button
            asChild
            size="sm"
            variant="accent"
            className="gap-2"
            onClick={() => trackFollowClick('facebook', placement)}
          >
            <a href={buildSocialUrl('facebook', `card:${placement}`)} target="_blank" rel="noopener noreferrer" aria-label="Følg Min Nye Elbil på Facebook">
              <Facebook className="w-4 h-4" /> Facebook
            </a>
          </Button>
          <Button
            asChild
            size="sm"
            variant="accent"
            className="gap-2"
            onClick={() => trackFollowClick('instagram', placement)}
          >
            <a href={buildSocialUrl('instagram', `card:${placement}`)} target="_blank" rel="noopener noreferrer" aria-label="Følg Min Nye Elbil på Instagram">
              <Instagram className="w-4 h-4" /> Instagram
            </a>
          </Button>
          <Button
            asChild
            size="sm"
            variant="accent"
            className="gap-2"
            onClick={() => trackFollowClick('youtube', placement)}
          >
            <a href={buildSocialUrl('youtube', `card:${placement}`)} target="_blank" rel="noopener noreferrer" aria-label="Følg Min Nye Elbil på YouTube">
              <Youtube className="w-4 h-4" /> YouTube
            </a>
          </Button>
        </div>
      </div>
    </Card>
  );
}
